import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image, Button } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import parse from 'html-react-parser';
// import Notification from '../navbars/Notification';
import BrandLogo from "../navbars/BrandLogo";
import NetworkStatus from "../navbars/NetworkStatus";
import '../navbars/_navbars.scss';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from '../../pages/GoogleAnalytics';
import {
    isMobile
} from "react-device-detect";
import PermissionRequest from './Anti_cheating/PermissionRequest';
import { brandLoginUrl } from "../../../utils/brandLogin";

class MockInstructions extends Component {
    constructor(props) {
        super(props)

        let examStartTimmer = "", timerStatus = false;
        const currentTime = Math.round((new Date()).getTime() / 1000);
        const examStartTime = this.props.examInstructions.start_time;

        if (!!examStartTime) {
            if (examStartTime <= currentTime) {
                examStartTimmer = 0;
                timerStatus = true;
            } else {
                examStartTimmer = parseInt(examStartTime) - parseInt(currentTime)
            }
        } else {
            examStartTimmer = 0;
            timerStatus = true;
        }


        this.state = {
            modalShow: false,
            checked: true,
            submitError: "",
            duplicateexam: "",
            examStartTimmer: examStartTimmer,
            timerStatus: timerStatus,
            hasPermissions: localStorage.getItem('proctoringBypassed') === 'true',
            proctoringBypassed: localStorage.getItem('proctoringBypassed') === 'true',
            showPermissionModal: false,
            isOnline: typeof navigator !== "undefined" && navigator.onLine !== undefined ? navigator.onLine : true
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener("online", this.handleConnectionChange);
        window.removeEventListener("offline", this.handleConnectionChange);
    }

    handleConnectionChange = () => {
        this.setState({ isOnline: navigator.onLine });
    }

    componentDidMount = () => {
        const bypassed = localStorage.getItem('proctoringBypassed') === 'true';
        if (bypassed) {
            this.setState({ hasPermissions: true, proctoringBypassed: true });
            if (this.props.onPermissionsGranted) {
                this.props.onPermissionsGranted(true, true);
            }
        }
        this.timer = setInterval(() => {
            this.timeFunction();
        }, 1000)
        window.addEventListener("online", this.handleConnectionChange);
        window.addEventListener("offline", this.handleConnectionChange);
    }

    handlePermissionGranted = (bypassed = false) => {
        localStorage.setItem('proctoringBypassed', bypassed);
        this.setState({ hasPermissions: true, proctoringBypassed: bypassed, showPermissionModal: false });
        if (this.props.onPermissionsGranted) {
            this.props.onPermissionsGranted(true, bypassed);
        }
    }

    handlePermissionDenied = (error) => {
        this.setState({ hasPermissions: false, showPermissionModal: false });
        if (this.props.onPermissionsGranted) {
            this.props.onPermissionsGranted(false);
        }
    }

    timeFunction = () => {
        //console.log("tottime", this.state.timerStatus);
        //console.log("tottime", this.state.examStartTimmer);
        if (this.state.timerStatus == false) {
            let examStartTimmer = parseInt(this.state.examStartTimmer) - 1;
            //console.log("tottimestatus", examStartTimmer);
            if (examStartTimmer == 0) {
                this.setState({
                    timerStatus: true,
                    examStartTimmer: examStartTimmer
                });
            }
            else {
                this.setState({
                    examStartTimmer: examStartTimmer
                });
            }
        }
    }
    handleStartExam = () => {
        // The exam can't load questions or submit without internet.
        if (!navigator.onLine) {
            this.setState({ isOnline: false });
            return;
        }
        const element = document.documentElement;
        // Start Exam click is the user gesture browsers need to enter full screen
        const etype = this.props.getData && this.props.getData.etype;
        const isScheduleExam = etype === "schedule" || etype === "schedulehome";
        try {
            if (element.requestFullscreen && isScheduleExam) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen && isScheduleExam) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen && isScheduleExam) {
                element.msRequestFullscreen();
            }
        } catch (err) {
        }

        localStorage.removeItem('proctoringViolations');
        if (this.props.startPracticeFun) {
            this.props.startPracticeFun();
        }
    }
    minutesTimer = (data) => {
        var date = new Date(data * 1000);
        var hh = date.getUTCHours();
        var mm = date.getUTCMinutes();
        var ss = date.getSeconds();
        if (hh < 10) { hh = "0" + hh; }
        if (mm < 10) { mm = "0" + mm; }
        if (ss < 10) { ss = "0" + ss; }
        var t = mm + ":" + ss;
        return t;
    }
    /* componentDidMount = () => {

        this.timer = setInterval(() => {
            this.timeFunction();
        }, 1000)
    } */

    handleOnChange = (e) => {
        if (e.target.name == "inspolicy") {
            if (this.state.checked == true) {
                this.setState({
                    checked: false,
                    submitError: "Please read the instructions and accept the conditions"
                });
            }
            else {
                this.setState({
                    checked: true,
                    submitError: "",
                });
            }
        }
        if (e.target.name == "duplicateexam") {
            if (e.target.value == "yes") {
                this.setState({
                    duplicateexam: true
                });

            }
            else {
                this.setState({
                    duplicateexam: false
                });
                this.props.history.push("/student/home");
            }


        }


    }

    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentemail");

            Cookies.remove("mobile");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("exam_name");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("videos");
            Cookies.remove("branch_name");
            Cookies.remove("role", "");
            Cookies.remove("profile_pic");
            Cookies.remove("student_userlevel");
            Cookies.remove("stulogintype", "");
            const institutionId119 = Cookies.get("institution_id");
            Cookies.remove("institution_id");
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('studentglobals');
            localStorage.removeItem('globalsubjects');
            if (brandLoginUrl(institutionId119)) {
                window.location.href = brandLoginUrl(institutionId119);
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    newTabFunction = () => {
        localStorage.setItem("subjectid", (this.props.history.location.state || {}).subjectid);
        localStorage.setItem("type", "practice");
        localStorage.setItem("ocid", (this.props.history.location.state || {}).ocid);
        localStorage.setItem("otid", (this.props.history.location.state || {}).otid);
        localStorage.setItem("hchaptername", (this.props.history.location.state || {}).hchaptername);
        localStorage.setItem("practice_type", 1);

        window.open("http://localhost:3000/student/subject/practice-test", "_blank") //to open new page
    }
    render() {
        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }
        const isuserValid = JSON.parse(
            isStudentUserValid.user_access_restictions
        );
        let instructions = "";
        if (this.props.type == "practice") {
            instructions = this.props.examInstructions.find((a) => a.is_exam == "0");
        }
        else {
            instructions = this.props.examInstructions
        }
        //console.log("MockInstructions", this.props.getData);
        let title = "";
        if (this.props.getData.etype == "schedule") {
            if (this.props.getData.mocktest == true) {
                title = GoogleAnalyticsArray[0].MockTest_Instruction_page;
                ReactGA.pageview('/student/subject/series_test', title);
            }
            else {
                title = GoogleAnalyticsArray[0].Schedule_Exam_instructions;
                ReactGA.pageview('/student/subject/series_test', title);
            }

        }
        else {
            if (this.props.getData.etype == "previous") {
                title = GoogleAnalyticsArray[0].Previous_Paper_Exam_Instructions;
                ReactGA.pageview('/student/subject/exam', title);
            }
            else if (this.props.getData.etype == "chapter") {
                const title = GoogleAnalyticsArray[0].Chapter_Exam_instructions;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }
            else if (this.props.getData.etype == "cumulative") {
                const title = GoogleAnalyticsArray[0].Cumulative_Exam_Instructions;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }
            else if (this.props.getData.etype == "grand") {
                const title = GoogleAnalyticsArray[0].Grand_Exam_Instructions;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }
            else if (this.props.getData.etype == "semi-grand") {
                const title = GoogleAnalyticsArray[0].Semi_grand_Exam_Instructions;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }
            else if (this.props.getData.etype == "error") {
                const title = GoogleAnalyticsArray[0].Error_Exam_Instruction;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }
            else if (this.props.getData.etype == "jeemainsprevious_exam") {
                const title = GoogleAnalyticsArray[0].Jee_Mains_2021_Instruction_page;
                ReactGA.pageview('/student/subject/exam', ["rizee"], title);
            }

        }
        title = GoogleAnalyticsArray[0].Exam_Instructions;
        ReactGA.pageview('/student/subject/series_test', title);

        //console.log("aaaa",localStorage.getItem("examtype_pattern"))
        return (
            <div className="Instructions">
                <Navbar className="header-top navbar navbar-expand-md navbar-white bg-white shadow-sm">
                    <Container>
                        <Link to="/student/home">
                            <BrandLogo width="159.501" />
                        </Link>

                        <Nav className="ml-auto align-items-center">
                            <NetworkStatus />
                            {/* <Notification /> */}
                            <NavDropdown id="basic-nav-dropdown2" className="no-arrow" alignRight title={
                                <div className="profile-img d-flex align-items-center">
                                    {localStorage.getItem("profile_pic") ? (

                                        <Image src={`https://support.rizee.in/files/${localStorage.getItem("profile_pic")}`} roundedCircle alt="profile-img" onError={(e) => { e.target.onerror = null; e.target.src = require('../../../images/businessman.png'); }} />
                                    ) : (
                                        <Image src={require('../../../images/businessman.png')} roundedCircle alt="profile-img" />
                                    )}

                                    <div className="text mx-2 mt-2">
                                        <div className="profile-name">{Cookies.get("studentusername")}</div>
                                        <small>Exam- {Cookies.get("exam_name")}, Class - {Cookies.get("classid") == "1" ? ("XI") : ("XII")}</small>
                                    </div>
                                </div>
                            }>
                                <NavDropdown.Item className="font-weight-bold">{Cookies.get("studentemail")}</NavDropdown.Item>
                                <NavDropdown.Divider />
                                {isuserValid.ins_profile_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/profile"><i className="far fa-user mr-2" /> My Profile</NavDropdown.Item>)}
                                {isuserValid.ins_package_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/package"><i className="far fa-sack mr-2" /> Package</NavDropdown.Item>)}

                                <NavDropdown.Item onClick={() => this.setState({ modalShow: true })}><i className="far fa-key mr-2" /> Change Password</NavDropdown.Item>
                                {isuserValid.ins_feedback_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/feedback"><i className="far fa-comment-alt-lines mr-2" /> Feedback</NavDropdown.Item>)}
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={Link} onClick={this.logout}><i className="far fa-sign-out mr-2" /> Logout</NavDropdown.Item>
                            </NavDropdown>

                        </Nav>
                    </Container>
                </Navbar>


                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-center align-items-center">
                        <div className="my-2 my-md-0 text-center">
                            {
                                localStorage.getItem("examtype_pattern") == "quiz_exam" ?
                                    (<h6 className="title mb-0 mr-4 text-white">Quiz Instructions</h6>)
                                    :
                                    (<h6 className="title mb-0 mr-4 text-white">{this.props.type == "exam" ? ("Exam") : ("Practise")} Instructions</h6>)
                            }

                        </div>
                        <div>&nbsp;</div>
                    </Container>
                    {
                        isMobile == true && Cookies.get("institution_id") == 30 ?
                            (
                                <Container fluid>
                                    <Row>
                                        <Col>

                                            {
                                                this.props.getData.etype == "error" ?
                                                    (
                                                        <Link to="/student/exams/error-exam">
                                                            <Button variant="light text-dark mr-2" className="float-right" > <i className="fas fa-long-arrow-alt-left" /> Back</Button>
                                                        </Link>
                                                    ) :
                                                    (
                                                        this.props.getData.etype == "schedule" ?
                                                            (
                                                                <Link to="/student/exams/test-series">
                                                                    <Button variant="light text-dark mr-2" className="float-right" > <i className="fas fa-long-arrow-alt-left" /> Back</Button>
                                                                </Link>
                                                            ) : (
                                                                <Link to="/student/exams/schedule-exam">
                                                                    <Button variant="light text-dark mr-2" className="float-right" > <i className="fas fa-long-arrow-alt-left" /> Back</Button>
                                                                </Link>
                                                            )
                                                    )
                                            }

                                        </Col>
                                    </Row>
                                </Container>
                            )
                            : (this.props.getData.etype == "schedule" || this.props.getData.etype == "schedulehome") ?
                                (
                                    // Schedule exams open in the same tab, so give a way back to the list.
                                    <Container fluid>
                                        <Row>
                                            <Col>
                                                <Link to="/student/exams/schedule-exam">
                                                    <Button variant="light text-dark mr-2" className="float-right" > <i className="fas fa-long-arrow-alt-left" /> Back</Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                : ("")
                    }

                </div>
                <div className="content-box pt-2" style={{ paddingBottom: '4rem' }}>
                    <Container>
                        <Row>
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <h6 className="mb-2"><u>Please read the following instructions carefully.</u></h6>
                                {instructions != undefined ? (parse(instructions.instructions)) : ("")}
                            </Col>
                        </Row>
                        {this.props.mains2021 == "1" ? (<Row className="mt-4">
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input type="checkbox"
                                            onChange={this.handleOnChange}
                                            className="form-check-input" value="" checked={this.state.checked} />I have red all the instructions and accepted.
                                    </label>
                                </div>
                            </Col>
                        </Row>) : ("")}
                        {this.state.submitError != "" ? (
                            <Row className="mt-1">
                                <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                    <h6 className="text-danger">{this.state.submitError}</h6>
                                </Col>
                            </Row>
                        ) : ("")}
                        {this.props.examInstructions.exam_status == "1" ? (
                            <React.Fragment>
                                <Row className="mt-4">
                                    <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                        <h6 className="text-danger"> {this.props.examInstructions.status_text}</h6>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                        <div className="d-flex justify-content-center">
                                            <div className="w-100 ml-2">
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input

                                                        type="radio"
                                                        id="customRadioType1"
                                                        value="yes"
                                                        name="duplicateexam"
                                                        className="custom-control-input"
                                                        onChange={this.handleOnChange}
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor="customRadioType1"
                                                    >
                                                        YES
                                                    </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input
                                                        type="radio"
                                                        id="customRadioType2"
                                                        value="no"
                                                        name="duplicateexam"
                                                        className="custom-control-input"
                                                        onChange={this.handleOnChange}
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor="customRadioType2"
                                                    >
                                                        NO
                                                    </label>
                                                </div>
                                            </div>
                                        </div>


                                    </Col>
                                </Row>
                            </React.Fragment>

                        )
                            : this.props.examInstructions.exam_status == "2" ? (
                                <Row className="mt-4">
                                    <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                        <h6 className="text-danger"> {this.props.examInstructions.status_text}</h6>
                                    </Col>
                                </Row>
                            )
                                : ("")}


                    </Container>
                </div>
                {this.props.examInstructions.exam_status == "0" || this.state.duplicateexam == true ? (
                    <div className="bg-white shadow-sm fixed-bottom">
                        <Container>
                            <Row>

                                {
                                    this.state.timerStatus == false && this.state.examStartTimmer != 0 ?
                                        (
                                            <Col sm={12}>
                                                <h5 className='text-center'>Your Exam Will Start in :  <span className='blink_me'>{this.minutesTimer(this.state.examStartTimmer)} </span> </h5>
                                            </Col>
                                        )
                                        :
                                        ("")
                                }

                                <React.Fragment>
                                    {!this.state.isOnline ? (
                                        <Col xl={12} lg={12} md={12} className="py-3 d-flex flex-wrap align-items-center justify-content-end">
                                            <span className="text-danger font-weight-bold mr-3 my-1">
                                                <i className="fas fa-wifi-slash mr-2" />You're offline. Connect to the internet to start.
                                            </span>
                                            <Button className='btn btn-outline-danger px-5 cursor_pointer_disabled' type="button" disabled>No internet</Button>
                                        </Col>
                                    ) : this.state.checked == true ? (
                                        <Col xl={12} lg={12} md={12} className="py-3 text-right">
                                            {
                                                this.state.timerStatus == true ?
                                                    (
                                                        localStorage.getItem("examtype_pattern") == "quiz_exam" ?
                                                            (
                                                                <a
                                                                    onClick={(() => {
                                                                        const proctoringData = (this.props.getAutoSubmitTime && Array.isArray(this.props.getAutoSubmitTime) ? this.props.getAutoSubmitTime[0] : this.props.getAutoSubmitTime) || {};
                                                                        const isProctoringEnabled = proctoringData.is_proctoring_enabled && Array.isArray(proctoringData.proctoring_attempt_limit) && proctoringData.proctoring_attempt_limit.some((r) => ![4, 7].includes(r.proctoring_type_id));
                                                                        return ((this.props.getData.etype === "schedule" || this.props.getData.etype === "schedulehome") && isProctoringEnabled && !this.state.hasPermissions) ? () => this.setState({ showPermissionModal: true }) : this.handleStartExam;
                                                                    })()}
                                                                    className="btn btn-outline-primary px-5">
                                                                    Start Quiz
                                                                </a>
                                                            )
                                                            :
                                                            (
                                                                <a
                                                                    onClick={(() => {
                                                                        const proctoringData = (this.props.getAutoSubmitTime && Array.isArray(this.props.getAutoSubmitTime) ? this.props.getAutoSubmitTime[0] : this.props.getAutoSubmitTime) || {};
                                                                        const isProctoringEnabled = proctoringData.is_proctoring_enabled && Array.isArray(proctoringData.proctoring_attempt_limit) && proctoringData.proctoring_attempt_limit.some((r) => ![4, 7].includes(r.proctoring_type_id));
                                                                        return ((this.props.getData.etype === "schedule" || this.props.getData.etype === "schedulehome") && isProctoringEnabled && !this.state.hasPermissions) ? () => this.setState({ showPermissionModal: true }) : this.handleStartExam;
                                                                    })()}
                                                                    className="btn btn-outline-primary px-5">
                                                                    {this.props.type == "exam" ? ("Start Test") : ("Start Practise")}
                                                                </a>
                                                            )

                                                    )
                                                    :
                                                    (
                                                        localStorage.getItem("examtype_pattern") == "quiz_exam" ?
                                                            (<Button className='btn btn-outline-primary px-5 cursor_pointer_disabled' type="button" disabled>Start Quiz</Button>)
                                                            :
                                                            (<Button className='btn btn-outline-primary px-5 cursor_pointer_disabled' type="button" disabled>{this.props.type == "exam" ? ("Start Test") : ("Start Practise")}</Button>)

                                                    )
                                            }
                                        </Col>
                                    ) : (
                                        <Col xl={12} lg={12} md={12} className="py-3 text-right">
                                            <a
                                                onClick={this.submitFun}

                                                className="btn btn-outline-primary px-5">
                                                {this.props.type == "exam" ? ("Start Exam") : ("Start Practise")}

                                            </a>
                                        </Col>
                                    )}
                                </React.Fragment>
                            </Row>
                        </Container>
                    </div>
                ) : ("")}

                {this.state.showPermissionModal && (
                    <PermissionRequest
                        onGranted={this.handlePermissionGranted}
                        onDenied={this.handlePermissionDenied}
                    />
                )}
            </div>
        )
    }
}


export default withRouter(MockInstructions);
